
import React from 'react';
import SharedLayout from '@/components/SharedLayout';
import SubpageNavigation from '@/components/SubpageNavigation';

const Pomodoro = () => {
  return (
    <SharedLayout>
      <div className="text-left px-6 py-12 max-w-4xl mx-auto">
        <SubpageNavigation />
        
        <h2 className="text-3xl font-bold mb-6 text-gray-800 dark:text-gray-100">The Pomodoro Technique</h2>
        <p className="mb-6 text-gray-700 dark:text-gray-200">
          The Pomodoro Technique is a time management method developed by Francesco Cirillo in the late 1980s. 
          It uses a timer to break down work into intervals, traditionally 25 minutes in length, separated by short breaks.
        </p>
        <h3 className="text-2xl font-bold mb-4 text-gray-800 dark:text-gray-100">How It Works</h3>
        <ol className="list-decimal pl-6 mb-8 text-gray-700 dark:text-gray-200">
          <li className="mb-2">Choose a task to work on</li>
          <li className="mb-2">Set the timer for 25 minutes</li>
          <li className="mb-2">Work on the task until the timer rings</li>
          <li className="mb-2">Take a short 5-minute break</li>
          <li className="mb-2">After 4 pomodoros, take a longer 15-30 minute break</li>
        </ol>
        <h3 className="text-2xl font-bold mb-4 text-gray-800 dark:text-gray-100">Benefits</h3>
        <ul className="list-disc pl-6 mb-8 text-gray-700 dark:text-gray-200">
          <li className="mb-2">Improved focus and concentration</li>
          <li className="mb-2">Better time awareness</li>
          <li className="mb-2">Reduced mental fatigue</li>
          <li className="mb-2">Enhanced motivation through frequent breaks</li>
          <li className="mb-2">Increased productivity</li>
        </ul>
      </div>
    </SharedLayout>
  );
};

export default Pomodoro;
